module.exports = __webpack_public_path__ + "img/wedding-1937022_1280.700cd81f.jpg";